import axios from 'axios';
import { MAISSBT_API_BASE_URL } from '../data/Constants';

const maisSbtClient = axios.create({
  baseURL: `${MAISSBT_API_BASE_URL}`
});

maisSbtClient.interceptors.response.use((response) => response);

maisSbtClient.interceptors.request.use((config: any) => {
  return {
    ...config,
    headers: {
      ...config.headers
    }
  };
});

export default maisSbtClient;
